import { html, unsafeCSS } from "lit";
import { customElement } from "lit/decorators.js";
import EkoElement from "@/utilities/element";
import style from "./command-menu-body.css?inline";

@customElement("eko-command-menu-body")
export class CommandMenuBody extends EkoElement {
  static styles = [...EkoElement.styles, unsafeCSS(style)];

  render() {
    return html`<slot></slot>`;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    "eko-command-menu-body": CommandMenuBody;
  }
}

export default CommandMenuBody;
